export const SHARED_OAUTH_CLIENT = {
  clientId:
    '548418788053-q7p964rqvjiv8ooamciprku6bpu34u9d.apps.googleusercontent.com',
  clientSecret: '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',
} as const
